import styled from "styled-components"

import Heading from "./Heading"

const H1 = styled.h1`
  ${Heading}

  font-size: 34px;
`

export default H1
